
var Model = require("../types/DebouncedModel.js");
var xtend = require("xtend");
var par = require("par");

module.exports = Model({
	name: "contactprofile",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,
	debounce: 100, // Debounce pushes by 50 milliseconds

	_who: "",
	_has_checked_managed: false,
	_people: null,
	_managed: null,
	_contacts: null,
	_available: null,
	_back: null,

	recalculate: recalculate,
});

function init() {
	this._who = "";
	this._people = {};
	this._managed = [];
	this._contacts = [];
	this._available = {};
	this._nologin = [];
	this._back = null;
	this._allowMessageOverride = false;

	this.push({});
}

function uninit() {
	this._who = "";
	this._people = null;
	this._managed = null;
	this._contacts = null;
	this._available = null;
	this._nologin = null;
	this._back = null;

}

function listeners() {
	return {
		"people:updated": saveAndRecalculate("_people"),
		"managedusers:updated": saveAndRecalculate("_managed"),
		"contacts:updated": saveAndRecalculate("_contacts"),
		"availability:updated": saveAndRecalculate("_available"),
		"nologinaccounts:updated": saveAndRecalculate("_nologin"),
	};
}

function triggers() {
	return {
		"profile:open": handle_trigger_profile_open,
		"clear": clear,
		"currentdestroyed": handleDestroyed
	};
}

function recalculate() {
	var id = this._who;
	if (!id) return;

	var person = this._people[id];
	if (!person) {
		if (this.data) this.push(null);
		return;
	}

	var isIn = par(personIn, id);
	var isManaged = isIn(this._managed);
	var isContact = isIn(this._contacts);
	var isAvailable = this._available[id];
	var canCall = isContact || isManaged && isAvailable;
	var isNoLogin = isIn(this._nologin);
	var hasCheckedManaged = this._has_checked_managed;
	var backButton = this._back;
	var allowMessage = this._allowMessageOverride;
	var patientId = this._patientId;

	if (isManaged && !hasCheckedManaged) {
		this._has_checked_managed = true;
		this.emit("managedaccount:trigger:open", {
			who: id,
			group: this._group
		});
	}

	this.push(xtend(person, {
		isManaged: isManaged,
		isContact: isContact,
		isAvailable: isAvailable,
		isNoLogin: isNoLogin,
		canCall: canCall,
		backButton: backButton,
		allowMessage: allowMessage,
		patientId: patientId
	}));
}

function handle_trigger_profile_open(data) {
	this._who = data.who;
	this._has_checked_managed = false;
	this._back = data.back;
	this._allowMessageOverride = data.message;
	this._group = data.group;
	this._patientId = data.patientId;

	this.dispatch("openedprofile", {
		who: this._who
	});

	this.emit("people:trigger:add", {
		lean: true,
		who: this._who
	});

	this.recalculate();

	const isIn = par(personIn, this._who);
	const isManaged = isIn(this._managed);
	!isManaged && this.emit("usermetrics:trigger:track", "view contact's profile", {
		who: this._who
	});
}

function saveAndRecalculate(name) {
	return function (data) {
		this[name] = data;
		this.recalculate();
	};
}

function personIn(person, list) {
	return list.some(function (item) {
		var other = item._id || item;
		return other === person;
	});
}

function clear(){
	this.emit("managedcontacts:trigger:reset");
	this._who = "";
	this._back = null;
	this._allowMessageOverride = false;
	this._has_checked_managed = false;
	this._patientId = null;
	this.push({});
}

function handleDestroyed(data) {
	if (data.who === this._who) this.emit("desktop:trigger:page:home");
}